import Reveal from "@stimulus-components/reveal";

export default class extends Reveal {
  static targets = ["item", "button"];

  declare readonly buttonTarget: HTMLButtonElement;
  declare readonly itemTarget: HTMLElement;

  connect() {
    super.connect();
    this.updateButton();
    window.addEventListener("resize", this.handleResize);
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize);
  }

  toggle() {
    super.toggle();
    this.updateButton();
  }

  private readonly handleResize = () => this.updateButton();

  private updateButton() {
    const expanded = !this.itemTarget.classList.contains(this.class);

    this.buttonTarget.hidden = !expanded && !this.isTruncated();
    this.buttonTarget.textContent = expanded ? "Show less" : "Read more";
    this.buttonTarget.setAttribute("aria-expanded", String(expanded));
  }

  private isTruncated() {
    return this.itemTarget.scrollHeight > this.itemTarget.clientHeight;
  }
}
